export function initMessageCompose(root = document) {
  const schoolSelect = root.querySelector("#new-thread-school");
  const sheetSelect = root.querySelector("#new-thread-sheet");
  if (!schoolSelect || !sheetSelect || sheetSelect.dataset.composeInitialized === "1") return;

  sheetSelect.dataset.composeInitialized = "1";
  const sheetOptions = Array.from(sheetSelect.options)
    .filter((option) => option.value !== "")
    .map((option) => ({
      value: option.value,
      text: option.textContent.trim(),
      schoolId: option.dataset.schoolId,
    }));
  const placeholder = sheetSelect.querySelector('option[value=""]').textContent.trim();

  const syncSheetOptions = () => {
    const options = sheetOptions.filter((option) => option.schoolId === schoolSelect.value);
    const selectedValue = options.some((option) => option.value === sheetSelect.value)
      ? sheetSelect.value
      : options[0]?.value ?? "";
    const tomSelect = sheetSelect.tomselect;

    if (tomSelect) {
      tomSelect.clear(true);
      tomSelect.clearOptions();
      tomSelect.addOption({ value: "", text: placeholder });
      tomSelect.addOption(options);
      tomSelect.setTextboxValue("");
      tomSelect.setValue(selectedValue, true);
      tomSelect.refreshOptions(false);
      if (options.length > 0) tomSelect.enable();
      else tomSelect.disable();
    } else {
      sheetSelect.replaceChildren(new Option(placeholder, ""), ...options.map((option) => new Option(option.text, option.value)));
      sheetSelect.value = selectedValue;
      sheetSelect.disabled = options.length === 0;
    }
  };

  schoolSelect.addEventListener("change", syncSheetOptions);
  syncSheetOptions();
}